import dynamic from 'next/dynamic';
import { CmsPlaceholders } from 'src/lib/constants';
import type { ICareersSearchProps } from '../Careers/CareersSearch.types';

// Dynamically import placeholders as they should be rarely
// used and we don't want them bundled with core pages.

const CareersSearch = dynamic<ICareersSearchProps>(() => {
  return import('../Careers/CareersSearch');
});

const CmsPlaceholderSwitch = ({ fields, sys }) => {
  const { placeholder } = fields;
  switch (placeholder) {
    case CmsPlaceholders.CAREERS_SEARCH:
      return <CareersSearch fields={fields} sys={sys} />;
  }
  return null;
};

export default CmsPlaceholderSwitch;
